import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

// 정렬 기준 3개(기본/사번/직급). 고른 칩을 한 번 더 누르면 오름↔내림이 바뀐다.
// 서버로 보내는 값(orderNm)은 예전과 같다: '' | usrNoAsc | usrNoDesc | gradeNmAsc | gradeNmDesc
const keys = [
    { key: '', label: '기본' },
    { key: 'usrNo', label: '사번' },
    { key: 'gradeNm', label: '직급' },
];

const parse = (orderName) => {
    const m = /^(usrNo|gradeNm)(Asc|Desc)$/.exec(orderName || '');
    return m ? { key: m[1], dir: m[2] } : { key: '', dir: null };
};

const EmpOrdList = ({ orderName, onChangeOrder }) => {
    const cur = parse(orderName);

    const handleClick = (key) => {
        if (!key) return onChangeOrder('');
        if (cur.key === key) return onChangeOrder(key + (cur.dir === 'Asc' ? 'Desc' : 'Asc'));
        return onChangeOrder(key + 'Asc');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                alignItems: 'center',
                gap: 0.75,
                m: { xs: 0, sm: 1 },
                mb: 1,
                mx: { xs: 0, sm: 2 },
            }}
        >
            <Typography variant="body2" color="text.secondary" sx={{ mr: 0.5, whiteSpace: 'nowrap' }}>
                정렬
            </Typography>
            {keys.map((k) => {
                const active = cur.key === k.key;
                const DirIcon = active && cur.dir === 'Desc' ? ArrowDownwardIcon : ArrowUpwardIcon;
                return (
                    <Chip
                        key={k.key || 'default'}
                        size="small"
                        label={k.label}
                        color={active ? 'primary' : 'default'}
                        variant={active ? 'filled' : 'outlined'}
                        icon={k.key && active ? <DirIcon sx={{ fontSize: 16 }} /> : undefined}
                        onClick={() => handleClick(k.key)}
                        title={k.key ? (active ? '한 번 더 누르면 정렬 방향이 바뀝니다' : `${k.label} 오름차순`) : '기본 정렬'}
                        sx={{ flexShrink: 0, px: 0.5 }}
                    />
                );
            })}
        </Box>
    );
};

export default EmpOrdList;
